export { default as ReservoirDepositTransactionCompleted } from './DepositTransactionCompleted';
export { default as DepositUpgradeCompleted } from './DepositUpgradeCompleted';
export { default as StakeTransactionCompleted } from './StakeTransactionCompleted';
export { default as TransactionError } from './TransactionError';
export { default as TransactionPending } from './TransactionPending';
export { default as UnstakeTransactionCompleted } from './UnstakeTransactionCompleted';
export { default as VaultWithdrawCompleted } from './VaultWithdrawCompleted';

export type TransactionStatus = 'CONFIRM' | 'PENDING' | 'ERROR' | 'COMPLETED';
